import React, { createContext, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const NavigationContext = createContext();

export const NavigationProvider = ({ children }) => {
  const [stack, setStack] = useState([{ path: "/configurations", label: "Home" }]);
  const navigate = useNavigate();
  const getLastIndex = () => stack.length - 1;
  const push = ({ path, label, state = {} }) => {
  setStack(prev => {
      const withoutDuplicates = prev.filter(item => item.path !== path);
      const newStack = [{ path, label, state }, ...withoutDuplicates];

      const fullPath = newStack
        .slice(0, -1)
        .reverse()
        .map(entry => entry.path.replace(/^\/+|\/+$/g, ''))
        .filter(Boolean)
        .join('/');

      
        navigate(fullPath, { state });

      return newStack;
    });
  };
  const clearStack = () => {
    setStack([{ path: "/configurations", label: "Home" }]);
  };


  const goToStack = (index) => {
  const target = stack.reverse()[index];
  console.log(index)
  if (!target) return;
  console.log(target.label)
  if (target.label === "Home"){
    clearStack();
    navigate("/configurations");
    return;
  } 
  const fullPath = stack
    .slice(1, index+1)
    .map(entry => entry.path)
    .join('/');
  console.log(fullPath)
  setStack(prev => {
    const newStack = prev.slice(0, index + 1).reverse();
    console.log("Stack dopo:", newStack);
    return newStack;
  });
  console.log("State:", target.state);
  navigate(fullPath, { state: target.state });
};


  return (
    <NavigationContext.Provider value={{ push, clearStack, goToStack, getLastIndex, setStack, stack }}>
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigationStack = () => useContext(NavigationContext);
